<template>
  <HcAlertItem class="top-tip-box" v-if="tipVisible" :type="tipInfo.type" :closable="false" show-icon >
    <template #title>
      <span>{{tipInfo.notice}}</span>
    </template>
  </HcAlertItem>
</template>

<script>
import apiCommon from '@/services/api/modules/common'
import HcAlertItem from '@/components/HcAlert/HcAlertItem.vue'
import { findMicroAppConfig } from '@/services/microFeUtil'

export default {
  name: 'TopTip',
  components: {
    HcAlertItem,
  },
  data() {
    return {
      timer: null,
      tipInfo: {
        // notice: '123',
        // type: 'warning',
        // scope: '', scb-front | erp | all
      }, // notice: string, type: string
    }
  },
  methods: {
    async flushTip() {
      try {
        const { code, data } = await apiCommon.fetchSysNotice() || {}
        if (code !== 200) {
          return
        }

        this.tipInfo = data
      } catch (error) {
        console.log(error)
      }
    }
  },
  computed: {
    tipVisible() {
      // 有内容
      // 在指定页面, 默认只能在bi的页面展示
      const { scope = 'scb-front', notice } = this.tipInfo
      // 是否有内容
      const isContent = !!notice

      if (!isContent) {
        return false
      }

      if (scope === 'all') {
        return isContent
      }

      // 指定 子app 才显示的提示
      const microApp = findMicroAppConfig(this.$route.path)
      if (!microApp) {
        return isContent
      }

      return isContent && microApp.name === scope
    }
  },
  created() {
    this.flushTip()
    // 每隔5分钟检测一次信息
    this.timer = setInterval(() => {
      this.flushTip()
    }, 1000 * 60 * 5)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>

<style lang="scss" scoped>
.top-tip-box {
  margin-top: 8px;
  margin-bottom: 8px;
}
</style>
